





































































































































































































































/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue } from 'vue-property-decorator';
import EditPanelComponent from '@/components/construction/constructionedit/EditPanelComponent.vue';
import ExpectedCostInput from '@/components/construction/constructionedit/expectedcostinput/ExpectedCostInput.vue';
import FixedCostInput from '@/components/construction/constructionedit/fixedcostinput/FixedCostInput.vue';
import InVoiceList from '@/components/construction/constructionedit/invoiceList/InVoiceList.vue';
import ApiResponseDialog from '@/components/common/modules/ApiResponseDialog.vue';
import Dialog from '@/components/common/modules/Dialog.vue';
import {
  ConstructionEditTabs,
  FrequentlyUsedWords
} from '@/constants/construction/constructionEdit';
import HexabaseApi from '@/services/hexabase/hexabaseApi';
import hexabaseState from '@/store/hexabase';
import authState from '@/store/auth';
import {
  optionalFormConstruction,
  optionalFormInVoice,
  optionalFormExpectedCostInputMaterialCost,
  optionalFormExpectedCostInputLaborCost,
  optionalFormExpectedCostInputConsumableCost,
  optionalFormFixedCostInputMaterialCost,
  optionalFormFixedCostInputLaborCost,
  optionalFormFixedCostInputConsumableCost
} from '@/constants/form/form';
import { FieldChildrenProp, FieldsInfo, HexaFileFieldResponse, ItemActions } from '@/services/hexabase/types';
import ConstructionModel from '@/models/constructionModel';
import ConstructionSubject from '@/models/data/constructionSubject';
import Customer from '@/models/data/customer';
import Department from '@/models/data/department';
import Staff from '@/models/data/staff';
import Material from '@/models/data/material';
import Supplier from '@/models/data/supplier';
import Subcontractor from '@/models/data/subcontractor';
import Unit from '@/models/data/unit';

import BaseModel from '@/models/baseModel';
import InVoice from '@/models/inVoice';
import ExpectedCostInputMaterialCost from '@/models/expectedCostInputMaterialCost';
import ExpectedCostInputLaborCost from '@/models/expectedCostInputLaborCost';
import ExpectedCostInputConsumableCost from '@/models/expectedCostInputConsumableCost';
import FixedCostInputMaterialCost from '@/models/fixedCostInputMaterialCost';
import FixedCostInputLaborCost from '@/models/fixedCostInputLaborCost';
import FixedCostInputConsumableCost from '@/models/fixedCostInputConsumableCost';
import DialogFormDownload from '@/components/common/modules/DialogFormDownload.vue';
import DialogRegisterCopyData from '@/components/common/modules/DialogRegisterCopyData.vue';
import { DialogStatusResponse } from '@/constants/sample';
import { FileFormResponse } from '@/constants/form/types';

@Component({
  components: {
    EditPanelComponent,
    ExpectedCostInput,
    FixedCostInput,
    InVoiceList,
    ApiResponseDialog,
    Dialog,
    DialogFormDownload,
    DialogRegisterCopyData
  }
})
export default class ConstructionEdit extends Vue {
  // タブ関連
  private name = 'tabs';
  currentTab = 0;
  id = 0;
  private tabName = '';
  private tabs = ConstructionEditTabs;

  // Validationエラー制御
  private invalid = true;

  private constructionModel = new ConstructionModel();
  private errorMess = '';
  private frequentlyUsedWords = FrequentlyUsedWords;

  private projectId = hexabaseState.applicationId;

  private constructionSubject = new ConstructionSubject();
  private customer = new Customer();
  private department = new Department();
  private staff = new Staff();
  private material = new Material();
  private supplier = new Supplier();
  private subcontractor = new Subcontractor();
  private unit = new Unit();

  private basicFieldsData: Array<FieldChildrenProp> = [];
  private basicFieldCols = '';
  private detailFieldsData: Array<FieldChildrenProp> = [];
  private detailFieldCols = '';

  private itemActions: Array<ItemActions> = [];
  private itemUpdateActionId = '';

  private masterData: { [k: string]: { [k: string]: Array<{ [k: string]: string }> } } = {};

  private mainDsId = hexabaseState.datastoreIds['工事'];

  private registData: any = {
    item: {},
    return_item_result: true, // true指定すると、登録されたアイテム情報を返します
    related_ds_items: {} // 関連するデータストアの新規・更新・削除を指定  詳細は以下を参照
  };

  private itemId = this.$route.params.id;
  private currentData: Array<FieldsInfo> = [];

  private registFieldType: any = {};

  // 添付ファイルフィールドのフィールド名
  private fileFieldDisplayId = "files";
  // Form非表示フィールド名
  private payoutClassDisplayId = "payout_class";
  private billingMonthDisplayId = "billing_month";
  private completionDateDisplayId = "completion_date";
  private registrationDateDisplayId = "registration_date";

  // 各画面情報、テーブル情報取得時に使用する変数
  private useModels: Array<BaseModel> = [];
  private useDetailFieldCols = '';
  private useDetailFieldsData: Array<Array<FieldChildrenProp>> = [];
  private useDefaultDetailFieldsData: Array<FieldChildrenProp> = [];
  // 請求書一覧
  private inVoiceDsId = hexabaseState.datastoreIds['請求書'];
  private inVoiceCurrentDetailData: any;
  private inVoice = new InVoice();
  private inVoiceDetailFieldsData: Array<Array<FieldChildrenProp>> = [];
  private inVoiceDetailFieldCols = '';
  private inVoiceDefaultDetailFieldsData: Array<FieldChildrenProp> = [];
  // 予定原価入力
  private expectedCostInputDsIds: any = [
    hexabaseState.datastoreIds['予定原価材料費明細'],
    hexabaseState.datastoreIds['予定原価労務費明細'],
    hexabaseState.datastoreIds['予定原価その他経費明細']
  ];
  private expectedCostInputCurrentDetailData: Array<object> = [];
  private expectedCostInputDetailFieldsData: Array<Array<Array<FieldChildrenProp>>> = [];
  private expectedCostInputDetailFieldCols: Array<string> = [];
  private optionalFormExpectedCost = [
    optionalFormExpectedCostInputMaterialCost,
    optionalFormExpectedCostInputLaborCost,
    optionalFormExpectedCostInputConsumableCost
  ];
  private expectedCostInputDefaultDetailFieldsData: Array<Array<FieldChildrenProp>> = [];
  // 確定原価入力
  private fixedCostInputDsIds: any = [
    hexabaseState.datastoreIds['確定原価材料費明細'],
    hexabaseState.datastoreIds['確定原価労務費明細'],
    hexabaseState.datastoreIds['確定原価その他経費明細']
  ];
  private fixedCostInputCurrentDetailData: Array<object> = [];
  private fixedCostInputDetailFieldsData: Array<Array<Array<FieldChildrenProp>>> = [];
  private fixedCostInputDetailFieldCols: Array<string> = [];
  private optionalFormFixedCost = [
    optionalFormFixedCostInputMaterialCost,
    optionalFormFixedCostInputLaborCost,
    optionalFormFixedCostInputConsumableCost
  ];
  private fixedCostInputDefaultDetailFieldsData: Array<Array<FieldChildrenProp>> = [];
  // 受注予定金額
  private estimateOrderPrice = '0';
  // 受注確定額
  private fixedOrderPrice = '0';

  // ダイアログ表示制御
  private dialogStatus = false;
  // 処理実行後のAPIレスポンス
  private apiResponse: { [k: string]: any } = {}; // 処理実行後のAPIレスポンス
  private pdfFileIds = ['', ''];
  private pdffieldIds = ['', ''];
  private pdfFileName = ['', ''];

  private searchPattern = 'm_'
  private deleteMasterIds:any = [];

  // ダイアログの表示制御値
  private formDownloadDialogStatus = false;
  // 帳票ダウンロード用アイテムデータ
  private downloadItem: any = {};

  // ダイアログの表示制御値
  private registerCopyDataStatus = false;

  // 編集モード判定制御値
  private isEditMode = false;

  // 一度でも編集を行ったかどうかの制御値(trueの場合、編集時のキャンセルボタン押下時に編集内容破棄確認ダイアログを表示)
  private isOnceEdit = false;

  // 変更内容破棄確認ダイアログの表示制御値
  private changeDestructionAlertDialogStatus = false;
  // 請求累計
  private sumBillingAmount?: string = '0';
  // 請求残
  private billingBalance?: string = '0';
  
  // 請求書一覧タブの決算年度、工事番号、期
  private invoiceTableData: any = {}

  async created() {
    // 既存アイテムを取得しアイテム情報・アクション情報を保持
    const constructionBasicResult = await this.constructionModel.getLinkedItems(
      hexabaseState.applicationId,
      this.mainDsId,
      this.itemId
    );
    constructionBasicResult.item_actions.forEach(v => this.itemActions.push(v));
    // DB登録用データを作成
    this.currentData = constructionBasicResult.field_values;

    // linked_items内マスタ情報の洗い出し
    this.deleteMasterIds = [];
    for (const key in constructionBasicResult.linked_items) {
      if(constructionBasicResult.linked_items[key].display_id.indexOf(this.searchPattern) === 0) {
        this.deleteMasterIds.push(key);
      }
    }
    // linked_items内マスタ情報の削除
    for (const key in this.deleteMasterIds) {
      delete constructionBasicResult.linked_items[this.deleteMasterIds[key]];
    }

    for (const key in this.currentData) {
      if (this.currentData[key].value) {
        this.registData.item[this.currentData[key].field_id] = this.currentData[key].value;
      }
      if (this.currentData[key].dataType === 'file') {
        this.registData.item[this.currentData[key].field_id] = (this.currentData[key].value === null || this.currentData[key].value.length === 0) ? [] : (this.currentData[key].value as HexaFileFieldResponse[]).map(file => file.file_id).filter(v => v);
      }
    }
    this.registData['rev_no'] = constructionBasicResult.rev_no;
    for (const key in constructionBasicResult.linked_items) {
      this.registData.related_ds_items = {
        ...this.registData.related_ds_items,
        ...this.modifyDetailItems(constructionBasicResult.linked_items[key])
      };
    }

    // 明細登録用データがない場合は明細追加時と同様に空の登録用データを用意
    for (const key in this.registData.related_ds_items) {
      if (this.registData.related_ds_items[key].length === 0) {
        this.registData.related_ds_items[key].push(
          {
            operation: 1,
            item: {}
          }
        );
      }
    }

    // 請求書テーブル
    this.inVoiceCurrentDetailData = constructionBasicResult.linked_items[this.inVoiceDsId];
    // 予定原価材料費明細テーブル、予定原価労務費明細テーブル、予定原価消耗品・その他経費明細テーブル
    this.expectedCostInputCurrentDetailData[0] =
      constructionBasicResult.linked_items[this.expectedCostInputDsIds[0]];
    this.expectedCostInputCurrentDetailData[1] =
      constructionBasicResult.linked_items[this.expectedCostInputDsIds[1]];
    this.expectedCostInputCurrentDetailData[2] =
      constructionBasicResult.linked_items[this.expectedCostInputDsIds[2]];
    // 確定原価材料費明細テーブル、確定原価労務費明細テーブル、確定原価消耗品・その他経費明細テーブル
    this.fixedCostInputCurrentDetailData[0] =
      constructionBasicResult.linked_items[this.fixedCostInputDsIds[0]];
    this.fixedCostInputCurrentDetailData[1] =
      constructionBasicResult.linked_items[this.fixedCostInputDsIds[1]];
    this.fixedCostInputCurrentDetailData[2] =
      constructionBasicResult.linked_items[this.fixedCostInputDsIds[2]];
    await this.getMasterData();
    await this.getBasicFields();

    // 取得で使用するモデルをセットする
    this.useModels[0] = new InVoice();
    await this.getDetailFields(
      this.inVoiceDsId,
      this.inVoiceCurrentDetailData,
      optionalFormInVoice,
      0
    );
    this.inVoiceDetailFieldCols = this.useDetailFieldCols;
    this.inVoiceDetailFieldsData = this.useDetailFieldsData;
    this.inVoiceDefaultDetailFieldsData = this.useDefaultDetailFieldsData;
    this.useDetailFieldsData = [];
    this.useDefaultDetailFieldsData = [];
    // 予定原価入力
    this.useModels[0] = new ExpectedCostInputMaterialCost();
    this.useModels[1] = new ExpectedCostInputLaborCost();
    this.useModels[2] = new ExpectedCostInputConsumableCost();
    for (let i = 0; i < this.expectedCostInputDsIds.length; i++) {
      await this.getDetailFields(
        this.expectedCostInputDsIds[i],
        this.expectedCostInputCurrentDetailData[i],
        this.optionalFormExpectedCost[i],
        i
      );
      this.$set(this.expectedCostInputDetailFieldCols, i, this.useDetailFieldCols);
      this.$set(this.expectedCostInputDetailFieldsData, i, this.useDetailFieldsData);
      this.$set(this.expectedCostInputDefaultDetailFieldsData, i, this.useDefaultDetailFieldsData);
      this.useDetailFieldsData = [];
      this.useDefaultDetailFieldsData = [];
    }
    // 確定原価材料費明細
    this.useModels[0] = new FixedCostInputMaterialCost();
    this.useModels[1] = new FixedCostInputLaborCost();
    this.useModels[2] = new FixedCostInputConsumableCost();
    for (let i = 0; i < this.fixedCostInputDsIds.length; i++) {
      await this.getDetailFields(
        this.fixedCostInputDsIds[i],
        this.fixedCostInputCurrentDetailData[i],
        this.optionalFormFixedCost[i],
        i
      );
      this.$set(this.fixedCostInputDetailFieldCols, i, this.useDetailFieldCols);
      this.$set(this.fixedCostInputDetailFieldsData, i, this.useDetailFieldsData);
      this.$set(this.fixedCostInputDefaultDetailFieldsData, i, this.useDefaultDetailFieldsData);
      this.useDetailFieldsData = [];
      this.useDefaultDetailFieldsData = [];
    }
    // 受注予定金額の取得
    let targetUser = this.currentData.find(function(v) {
      if (v.field_id === 'estimate_order_price') {
        return v.value;
      }
    });
    this.estimateOrderPrice = String(targetUser?.value);
    // 受注確定金額の取得
    targetUser = this.currentData.find(function(v) {
      if (v.field_id === 'fixed_order_price') {
        return v.value;
      }
    });
    this.fixedOrderPrice = String(targetUser?.value);

    // 請求累計・請求残をセット
    const numSumBillingAmount = Number(this.calcBillingAmount(this.inVoiceDetailFieldsData));
    this.sumBillingAmount = String(numSumBillingAmount.toLocaleString());
    const numBillingBalance = Number(this.fixedOrderPrice !== 'undefined' ? this.fixedOrderPrice : '0') - Number(numSumBillingAmount);
    this.billingBalance = String(numBillingBalance.toLocaleString());
    // 請求書一覧に表示する決算年度、工事番号、工事科目のデータの整形
    this.basicFieldsData.forEach((item: any) => {
      if (item.display_id === 'fiscal_year') {
        // this.invoiceTableData['fiscal_year'] = item.props.value;
        this.$set(this.invoiceTableData, 'fiscal_year', item.props.value);
      } else if (item.display_id === 'period') {
        this.$set(this.invoiceTableData, 'period', item.props.value);
      } else if (item.display_id === 'construction_no') {
        this.$set(this.invoiceTableData, 'construction_no', item.props.value);
      } else if (item.display_id === 'construction_subject_id') {
        this.$set(this.invoiceTableData, 'construction_subject_id', item.props.value);
        this.$set(this.invoiceTableData, 'construction_subject_name', item.props.body[item.props.value - 1].name);
      } else if (item.display_id === 'title_disp') {
        this.$set(this.invoiceTableData, 'title_disp', item.props.value);
      }
    })
  }

  /**
   * 予定原価入力の子コンポーネントから入力データを取得して、明細情報削除処理
   * @module expectedCostInputDeleteRow
   * @param {any} data - 子コンポーネントより渡される値
   * @return {void}
   */
  private expectedCostInputDeleteRow(data: any) {
    // 編集を行ったかどうかの制御値をtrueにする
    this.isOnceEdit = true;
    const filtered = this.registData.related_ds_items[this.expectedCostInputDsIds[data.detailTypeIndex]].filter((e: any) => e.operation !== 3);
    if (filtered[data.index]) {
      if ('i_id' in filtered[data.index]) {
        filtered[data.index].operation = 3;
      } else {
        // 削除用に文字列を追加して、findIndexでindex番号取得して、明細を削除する
        filtered[data.index].operation = 'delete';
        const deleteIndex = this.registData.related_ds_items[this.expectedCostInputDsIds[data.detailTypeIndex]].findIndex((v:any) => {
          if (v) {
            return v.operation === 'delete';
          }
          return false;
        });
        this.registData.related_ds_items[this.expectedCostInputDsIds[data.detailTypeIndex]].splice(deleteIndex, 1);
      }
    }

    this.expectedCostInputDetailFieldsData[data.detailTypeIndex].splice(data.index, 1);
    // 明細削除により、props内のnameで番号がずれるので再設定
    for (const detailItemIndex in this.expectedCostInputDetailFieldsData[data.detailTypeIndex]) {
      for (const itemIndex in this.expectedCostInputDetailFieldsData[data.detailTypeIndex][detailItemIndex]) {
        // 項目が数量、単価、単位の場合は連結した固定の文字列になる
        const checkName = this.expectedCostInputDetailFieldsData[data.detailTypeIndex][detailItemIndex][itemIndex]['props']!['labelName'];
        if (checkName === 'quantity' || checkName === 'unit_price' || checkName === 'unit') {
          this.expectedCostInputDetailFieldsData[data.detailTypeIndex][detailItemIndex][itemIndex]['props']!['name'] = `quantity;unit_price;unit;[${detailItemIndex}]`;
        } else {
          this.expectedCostInputDetailFieldsData[data.detailTypeIndex][detailItemIndex][itemIndex]['props']!['name'] = `${this.expectedCostInputDetailFieldsData[data.detailTypeIndex][detailItemIndex][itemIndex]['props']!['labelName']}[${detailItemIndex}]`;
        }
      }
    }
  }

  /**
   * 予定原価入力の子コンポーネントから入力データを取得して、表示情報を更新
   * @module expectedCostInputCatchInputDetail
   * @param {any} response - 子コンポーネントより渡される値
   * @return {void}
   */
  private expectedCostInputCatchInputDetail(response: any) {
    const inputName = response.name;
    const inputValue = response.value;
    const index = inputName.match(/[\d+]{1,}/);
    const checkName = inputName.slice(0, inputName.lastIndexOf('['));
    let deepIndex = 0;
    let baseValueName = '';
    // 編集を行ったかどうかの制御値をtrueにする
    this.isOnceEdit = true;

    // 入力項目が数量、単価、単位の場合
    if (checkName === 'quantity' || checkName === 'unit_price' || checkName === 'unit') {
      baseValueName = 'quantity;unit_price;unit;' + '[' + index + ']';
      deepIndex = this.constructionModel.getDetailFieldsDataDeepIndex(
        this.expectedCostInputDetailFieldsData[response.detailTypeIndex][index],
        baseValueName
      );
      if (deepIndex) {
        let baseValue = this.expectedCostInputDetailFieldsData[response.detailTypeIndex][index][deepIndex]['props']!.value;
        let quantity = Number(baseValue.split(';')[0]);
        let unitPrice = Number(baseValue.split(';')[1]);
        let unit = baseValue.split(';')[2];
        if (checkName === 'quantity') {
          quantity = inputValue;
        } else if (checkName === 'unit_price') {
          unitPrice = inputValue;
        } else if (checkName === 'unit') {
          unit = inputValue;
        }
        baseValue = quantity + ';' + unitPrice + ';' + unit;
        // Vueにデータ変更を検出させるために$setを利用する
        this.$set(this.expectedCostInputDetailFieldsData[response.detailTypeIndex][index][deepIndex]['props']!, 'value', baseValue);
      }
    } else {
      // 入力された情報から表示情報を更新
      deepIndex = this.constructionModel.getDetailFieldsDataDeepIndex(this.expectedCostInputDetailFieldsData[response.detailTypeIndex][index], inputName);
      if (deepIndex) {
        // Vueにデータ変更を検出させるために$setを利用する
        this.$set(this.expectedCostInputDetailFieldsData[response.detailTypeIndex][index][deepIndex]['props']!, 'value', inputValue);
      }
    }
  }

  /**
   * 予定原価入力の子コンポーネントから入力データを取得して、更新情報に書き込む
   * @module expectedCostInputCreateDetailsData
   * @param {any} response - 子コンポーネントより渡される値
   * @return {void}
   */
  private expectedCostInputCreateDetailsData(data: any): void {
    this.registData.related_ds_items[this.expectedCostInputDsIds[data.detailTypeIndex]] = [];
    for (const i in data.response) {
      // 期と工事番号がない場合は追加する
      data.response[i] = this.addCreateDetailsBasicData(this.basicFieldsData, data.response[i], [
        'period',
        'construction_no'
      ]);
      this.registData.related_ds_items[this.expectedCostInputDsIds[data.detailTypeIndex]].push(
        data.response[i]
      );
    }
  }

  /**
   *  予定原価入力の子コンポーネントから通知を受けて、明細情報を追加表示する
   * @module expectedCostInputConsumableCostAddDetailArea
   * @return {void}
   */
  private expectedCostInputAddDetailArea(response: any): void {
    const i = this.expectedCostInputDetailFieldsData[response.detailTypeIndex].length;
    const temp: Array<FieldChildrenProp> = JSON.parse(
      JSON.stringify(this.expectedCostInputDefaultDetailFieldsData[response.detailTypeIndex])
    );
    temp.forEach((val, index) => {
      if ('props' in temp[index] && temp[index]['props'] !== undefined) {
        temp[index]['props']!['name'] = `${temp[index]['props']!['name']}[${i}]`;
      }
    });
    this.expectedCostInputDetailFieldsData[response.detailTypeIndex].push(temp);
    this.registData.related_ds_items[this.expectedCostInputDsIds[response.detailTypeIndex]].push(
      {
        operation: 1,
        item: {}
      }
    );
  }

  /**
   * 確定原価入力の子コンポーネントから入力データを取得して、明細情報削除処理
   * @module fixedCostInputDeleteRow
   * @param {any} data - 子コンポーネントより渡される値
   * @return {void}
   */
  private fixedCostInputDeleteRow(data: any) {
    // 編集を行ったかどうかの制御値をtrueにする
    this.isOnceEdit = true;
    const filtered = this.registData.related_ds_items[this.fixedCostInputDsIds[data.detailTypeIndex]].filter((e: any) => e.operation !== 3);
    if (filtered[data.index]) {
      if ('i_id' in filtered[data.index]) {
        filtered[data.index].operation = 3;
      } else {
        // 削除用に文字列を追加して、findIndexでindex番号取得して、明細を削除する
        filtered[data.index].operation = 'delete';
        const deleteIndex = this.registData.related_ds_items[this.fixedCostInputDsIds[data.detailTypeIndex]].findIndex((v:any) => {
          if (v) {
            return v.operation === 'delete';
          }
          return false;
        });
        this.registData.related_ds_items[this.fixedCostInputDsIds[data.detailTypeIndex]].splice(deleteIndex, 1);
      }
    }

    this.fixedCostInputDetailFieldsData[data.detailTypeIndex].splice(data.index, 1);
    // 明細削除により、props内のnameで番号がずれるので再設定
    for (const detailItemIndex in this.fixedCostInputDetailFieldsData[data.detailTypeIndex]) {
      for (const itemIndex in this.fixedCostInputDetailFieldsData[data.detailTypeIndex][detailItemIndex]) {
        // 項目が数量、単価、単位の場合は連結した固定の文字列になる
        const checkName = this.fixedCostInputDetailFieldsData[data.detailTypeIndex][detailItemIndex][itemIndex]['props']!['labelName'];
        if (checkName === 'quantity' || checkName === 'unit_price' || checkName === 'unit') {
          this.fixedCostInputDetailFieldsData[data.detailTypeIndex][detailItemIndex][itemIndex]['props']!['name'] = `quantity;unit_price;unit;[${detailItemIndex}]`;
        } else {
          this.fixedCostInputDetailFieldsData[data.detailTypeIndex][detailItemIndex][itemIndex]['props']!['name'] = `${this.fixedCostInputDetailFieldsData[data.detailTypeIndex][detailItemIndex][itemIndex]['props']!['labelName']}[${detailItemIndex}]`;
        }
      }
    }
  }

  /**
   * 確定原価入力の子コンポーネントから入力データを取得して、表示情報を更新
   * @module fixedCostInputCatchInputDetail
   * @param {any} response - 子コンポーネントより渡される値
   * @return {void}
   */
  private fixedCostInputCatchInputDetail(response: any) {
    const inputName = response.name;
    const inputValue = response.value;
    const index = inputName.match(/[\d+]{1,}/);
    const checkName = inputName.slice(0, inputName.lastIndexOf('['));
    let deepIndex = 0;
    let baseValueName = '';
    // 編集を行ったかどうかの制御値をtrueにする
    this.isOnceEdit = true;

    // 入力項目が数量、単価の場合に自動集計フィールドを更新
    if (checkName === 'quantity' || checkName === 'unit_price' || checkName === 'unit') {
      baseValueName = 'quantity;unit_price;unit;' + '[' + index + ']';
      deepIndex = this.constructionModel.getDetailFieldsDataDeepIndex(
        this.fixedCostInputDetailFieldsData[response.detailTypeIndex][index],
        baseValueName
      );
      if (deepIndex) {
        let baseValue = this.fixedCostInputDetailFieldsData[response.detailTypeIndex][index][deepIndex]['props']!.value;
        let quantity = Number(baseValue.split(';')[0]);
        let unitPrice = Number(baseValue.split(';')[1]);
        let unit = baseValue.split(';')[2];
        if (checkName === 'quantity') {
          quantity = inputValue;
        } else if (checkName === 'unit_price') {
          unitPrice = inputValue;
        } else if (checkName === 'unit') {
          unit = inputValue;
        }
        baseValue = quantity + ';' + unitPrice + ';' + unit;
        // Vueにデータ変更を検出させるために$setを利用する
        this.$set(this.fixedCostInputDetailFieldsData[response.detailTypeIndex][index][deepIndex]['props']!, 'value', baseValue);
      }
    } else {
      deepIndex = this.constructionModel.getDetailFieldsDataDeepIndex(
        this.fixedCostInputDetailFieldsData[response.detailTypeIndex][index],
        inputName
      );
      if (deepIndex) {
        // Vueにデータ変更を検出させるために$setを利用する
        this.$set(this.fixedCostInputDetailFieldsData[response.detailTypeIndex][index][deepIndex]['props']!, 'value', inputValue);
      }
    }
  }

  /**
   * 確定原価入力の子コンポーネントから入力データを取得して、更新情報に書き込む
   * @module fixedCostInputCreateDetailsData
   * @param {any} response - 子コンポーネントより渡される値
   * @return {void}
   */
  private fixedCostInputCreateDetailsData(data: any): void {
    this.registData.related_ds_items[this.fixedCostInputDsIds[data.detailTypeIndex]] = [];
    for (const i in data.response) {
      // 期と工事番号がない場合は追加する
      data.response[i] = this.addCreateDetailsBasicData(this.basicFieldsData, data.response[i], [
        'period',
        'construction_no'
      ]);
      this.registData.related_ds_items[this.fixedCostInputDsIds[data.detailTypeIndex]].push(
        data.response[i]
      );
    }
  }

  /**
   *  確定原価入力の子コンポーネントから通知を受けて、明細情報を追加表示する
   * @module fixedCostInputConsumableCostAddDetailArea
   * @return {void}
   */
  private fixedCostInputAddDetailArea(response: any): void {
    const i = this.fixedCostInputDetailFieldsData[response.detailTypeIndex].length;
    const temp: Array<FieldChildrenProp> = JSON.parse(
      JSON.stringify(this.fixedCostInputDefaultDetailFieldsData[response.detailTypeIndex])
    );
    temp.forEach((val, index) => {
      if ('props' in temp[index] && temp[index]['props'] !== undefined) {
        temp[index]['props']!['name'] = `${temp[index]['props']!['name']}[${i}]`;
      }
    });
    this.fixedCostInputDetailFieldsData[response.detailTypeIndex].push(temp);
    this.registData.related_ds_items[this.fixedCostInputDsIds[response.detailTypeIndex]].push(
      {
        operation: 1,
        item: {}
      }
    );
  }

  /**
   * 請求書一覧の子コンポーネントから入力データを取得して、明細情報削除処理
   * @module inVoiceDeleteRow
   * @param {any} data - 子コンポーネントより渡される値
   * @return {void}
   */
  private inVoiceDeleteRow(data: any) {
    // 編集を行ったかどうかの制御値をtrueにする
    this.isOnceEdit = true;
    const filtered = this.registData.related_ds_items[this.inVoiceDsId].filter((e: any) => e.operation !== 3);
    if (filtered[data.index]) {
      if ('i_id' in filtered[data.index]) {
        filtered[data.index].operation = 3;
      } else {
        // 削除用に文字列を追加して、findIndexでindex番号取得して、明細を削除する
        filtered[data.index].operation = 'delete';
        const deleteIndex = this.registData.related_ds_items[this.inVoiceDsId].findIndex((v:any) => {
          if (v) {
            return v.operation === 'delete';
          }
          return false;
        });
        this.registData.related_ds_items[this.inVoiceDsId].splice(deleteIndex, 1);
      }
    }

    this.inVoiceDetailFieldsData.splice(data.index, 1);
    // 明細削除により、props内のnameで番号がずれるので再設定
    for (const detailItemIndex in this.inVoiceDetailFieldsData) {
      for (const itemIndex in this.inVoiceDetailFieldsData[detailItemIndex]) {
        this.inVoiceDetailFieldsData[detailItemIndex][itemIndex]['props']!['name'] = `${this.inVoiceDetailFieldsData[detailItemIndex][itemIndex]['props']!['labelName']}[${detailItemIndex}]`;
      }
    }    
  }

  /**
   * 請求書一覧の子コンポーネントから入力データを取得して、表示情報を更新
   * @module inVoiceCatchInputDetail
   * @param {any} response - 子コンポーネントより渡される値
   * @return {void}
   */
  private inVoiceCatchInputDetail(response: any) {
    const inputName = response.name;
    const inputValue = response.value;
    const index = inputName.match(/[\d+]{1,}/);
    const deepIndex = this.inVoiceDetailFieldsData[index].findIndex(v => {
      if (v.props) {
        return v.props.name === inputName;
      }
      return false;
    });
    // 編集を行ったかどうかの制御値をtrueにする
    this.isOnceEdit = true;

    if (deepIndex) {
      this.inVoiceDetailFieldsData[index][deepIndex]['props']!.value = inputValue;
    }
  }

  /**
   * 請求書一覧の子コンポーネントから入力データを取得して、更新情報に書き込む
   * @module inVoiceCreateDetailsData
   * @param {any} response - 子コンポーネントより渡される値
   * @return {void}
   */
  private inVoiceCreateDetailsData(response: any): void {
    this.registData.related_ds_items[this.inVoiceDsId] = [];
    for (const i in response) {
      // 期と工事番号がない場合は追加する
      response[i] = this.addCreateDetailsBasicData(this.basicFieldsData, response[i], [
        'period',
        'construction_no'
      ]);
      this.registData.related_ds_items[this.inVoiceDsId].push(response[i]);
    }
  }

  /**
   * 請求書一覧の子コンポーネントから通知を受けて、明細情報を追加表示する
   * @module inVoiceAddDetailArea
   * @return {void}
   */
  private inVoiceAddDetailArea(): void {
    const i = this.inVoiceDetailFieldsData.length;
    const temp: Array<FieldChildrenProp> = JSON.parse(
      JSON.stringify(this.inVoiceDefaultDetailFieldsData)
    );
    temp.forEach((val, index) => {
      if ('props' in temp[index] && temp[index]['props'] !== undefined) {
        temp[index]['props']!['name'] = `${temp[index]['props']!['name']}[${i}]`;
      }
    });
    this.inVoiceDetailFieldsData.push(temp);
    this.registData.related_ds_items[this.inVoiceDsId].push(
      {
        operation: 1,
        item: {}
      }
    );
  }

  /**
   * data内に指定された情報がない場合に指定した情報の内容を追加する
   * @module addCreateDetailsBasicData
   * @param {any} addData - 追加元のデータ
   * @param {any} data - 確認・追加されるデータ
   * @param {any} strArray - 検索に使用される文字配列
   * @return data - 不足情報を追加されたデータ
   */
  private addCreateDetailsBasicData(addData: any, data: any, strArray: any) {
    let deepIndex = 0;
    for (const i in strArray) {
      if (!data.item[strArray[i]]) {
        deepIndex = this.constructionModel.getDetailFieldsDataDeepIndex(addData, strArray[i]);
        if (deepIndex) {
          data.item[strArray[i]] = this.basicFieldsData[deepIndex]['props']!.value;
        }
      }
    }
    return data;
  }

  private async tabChange(index: number) {
    this.currentTab = index;
  }

  /**
   * 各種入力フォームで使用するマスタを取得します
   */
  private async getMasterData() {
    const mData: { [k: string]: { [k: string]: Array<{ [k: string]: string }> } } = {};
    mData['m_construction_subject'] = await this.constructionSubject
      .getData()
      .then((data) => this.constructionModel.modifyMasterData(data, 'id', 'm_construction_subject'));
    mData['m_customer'] = await this.customer
      .getData()
      .then((data) => this.constructionModel.modifyMasterData(data, 'id', 'm_customer'));
    mData['m_department'] = await this.department
      .getData()
      .then((data) => this.constructionModel.modifyMasterData(data, 'id', 'm_department'));
    mData['m_staff'] = await this.staff
      .getData()
      .then((data) => this.constructionModel.modifyMasterData(data, 'id', 'm_staff'));
    mData['m_material'] = await this.material
      .getData()
      .then((data) => this.constructionModel.modifyMasterData(data, 'id', 'm_material'));
    mData['m_supplier'] = await this.supplier
      .getData()
      .then((data) => this.constructionModel.modifyMasterData(data, 'id', 'm_supplier'));
    mData['m_subcontractor'] = await this.subcontractor
      .getData()
      .then((data) => this.constructionModel.modifyMasterData(data, 'id', 'm_subcontractor'));
    mData['m_unit'] = await this.unit
      .getData()
      .then((data) => this.constructionModel.modifyMasterData(data, 'id', 'm_unit'));
    this.masterData = mData;
  }

  /**
   * 基本情報入力フォームを生成するための設定情報を取得・整形します
   */
  private async getBasicFields() {
    try {
      const actionList = this.itemActions.find(v => v.action_name === '内容を更新する');
      this.itemUpdateActionId = actionList!.action_id;
      if (actionList === undefined) throw new Error('not action');
      const inputFields = await this.constructionModel
        .getFieldsByActionId(this.mainDsId, actionList!.action_id)
        .then((data) => {
          return data;
        });
      for (const key in inputFields.action_fields) {
        this.registFieldType[inputFields.action_fields[key].display_id] =
          inputFields.action_fields[key].dataType;
      }
      const data = await this.constructionModel
        .makeFieldsList(this.projectId, this.mainDsId, this.currentData)
        .then((data) => {
          return this.constructionModel
            .addOptionalFormField(data, JSON.parse(JSON.stringify(optionalFormConstruction)))
            .map((field) => this.constructionModel.inputRestriction(field, inputFields))
            .map((field) => this.constructionModel.addOptionalMasterData(field, this.masterData))
            .map((field) => this.constructionModel.setPropsByLocalProperty(field, this))
            .map((field) => {
              // 添付ファイルフィールド
              if(field.display_id === this.fileFieldDisplayId){
                // (タブ内で)添付ファイルボタンは非表示(画面上に表示しないがファイルマネージャモーダルは機能する形を想定)
                field = {
                  ...field,
                  ...{
                    show: false
                  }
                };
              }
              return field;
            });
        });
      this.basicFieldCols = this.constructionModel.getGridStatus(data);
      this.basicFieldsData = data;
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * 明細入力フォームを生成するための設定情報を取得・整形します
   */
  private async getDetailFields(
    relatedDsId: string,
    setData: any,
    optionalForm: any,
    index: number
  ) {
    try {
      const newAction = await this.useModels[index].getNewActionList(relatedDsId).then((data) => {
        return data;
      });
      const inputFields = await this.useModels[index]
        .getFieldsByActionId(relatedDsId, newAction.actions[0].action_id)
        .then((data) => {
          return data;
        });
      const data = await this.useModels[index]
        .makeFieldsList(this.projectId, relatedDsId)
        .then((data) => {
          this.useModels[index].addDataNotExistHexabase(data, optionalForm);
          return this.useModels[index]
            .addOptionalFormField(data, JSON.parse(JSON.stringify(optionalForm)))
            .map((field) => this.useModels[index].inputRestriction(field, inputFields))
            .map((field) => this.useModels[index].addOptionalMasterData(field, this.masterData))
            .map((field) => {
              // Form非表示項目制御
              if(field.display_id === 'supplier_name' && relatedDsId !== hexabaseState.datastoreIds['確定原価材料費明細']){
                field = {
                  ...field,
                  ...{
                    show: false
                  }
                };
              }
              if(field.display_id === 'supplier_id' && relatedDsId !== hexabaseState.datastoreIds['確定原価材料費明細']){
                field = {
                  ...field,
                  ...{
                    show: false
                  }
                };
              }
              if(field.display_id === 'subcontractor_name'){
                field = {
                  ...field,
                  ...{
                    show: false
                  }
                };
              }
              if(field.display_id === 'subcontractor_id'){
                field = {
                  ...field,
                  ...{
                    show: false
                  }
                };
              }
              return field;
            });
        });
      this.useDetailFieldCols = this.constructionModel.getGridStatus(data);
      const detailAreas: Array<Array<FieldChildrenProp>> = this.useModels[
        index
      ].getCurrentDetailArea(setData, data);
      for (const key in detailAreas) {
        const targetFieldQuantity = detailAreas[key].find(function(v) {
          if (v.display_id === 'quantity') {
            return v;
          }
        });
        const targetFieldUnitPrice = detailAreas[key].find(function(v) {
          if (v.display_id === 'unit_price') {
            return v;
          }
        });
        const targetFieldUnit = detailAreas[key].find(function(v) {
          if (v.display_id === 'unit') {
            return v;
          }
        });
        if (targetFieldQuantity && targetFieldUnitPrice && targetFieldUnit) {
          targetFieldQuantity.display_id =
            targetFieldQuantity.display_id + ';' + targetFieldUnitPrice.display_id + ';' + targetFieldUnit.display_id;
          // undefinedに対処：quantity、unit_price→数値のためundefined(および空文字)の場合「0」、unit→文字列のためundefinedの場合は空文字
          targetFieldQuantity.props!.value =
            (targetFieldQuantity.props!.value || 0) + ';' + (targetFieldUnitPrice.props!.value || 0) + ';' + (targetFieldUnit.props!.value ?? '');
          const deepIndex = detailAreas[key].findIndex(v => {
            if (v.display_id === 'unit_price') {
              return v;
            }
          });
          detailAreas[key].splice(deepIndex, 1);
          const deepIndex2 = detailAreas[key].findIndex(v => {
            if (v.display_id === 'unit') {
              return v;
            }
          });
          detailAreas[key].splice(deepIndex2, 1);
        }
      }

      // 明細件数が0件、明細追加時に使用する空フォームで特定の設定を行う
      const baseDefaultData = [];
      for (const index in data) {
        if ('quantity' === data[index].display_id) {
          data[index].display_id = 'quantity;unit_price;unit';
        }
        if ('unit_price' !== data[index].display_id && 'unit' !== data[index].display_id) {
          baseDefaultData.push(data[index]);
        }
      }

      this.useDetailFieldsData =
        detailAreas.length === 0
          ? this.useModels[index].createInitialDetailBoxGeneric(baseDefaultData)
          : detailAreas;

      this.useDefaultDetailFieldsData = JSON.parse(JSON.stringify(baseDefaultData));
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * 子コンポーネントからEmitされる値インサート用に加工（基本情報）
   * （値が渡されるか確認用）
   * @module catchInputBasic
   * @param {any} response - 子コンポーネントより渡される値
   * @return {void}
   */
  private catchInputBasic(response: any) {
    const inputName = response.name;
    const inputValue = response.value;
    // 編集を行ったかどうかの制御値をtrueにする
    this.isOnceEdit = true;

    if (inputName === 'construction_staff_id') {
      // 担当者マスタ情報から選択されたconstruction_staff_idに関する情報を引き出す
      const checkItem = this.masterData['m_staff'].body.find(v => {
        if (v.id) {
          return v.id === inputValue;
        }
        return false;
      });
      // 部門マスタ情報から選択された担当者マスタ情報のdepartment_idと紐づく情報を引き出す
      const setItem = this.masterData['m_department'].body.find(v => {
        if (v.id) {
          return v.id === checkItem?.department_id;
        }
        return false;
      });
      // 工事基本情報からsupplier_idに該当するインデックスを検索する
      const deepIndex = this.constructionModel.getDetailFieldsDataDeepIndex(
        this.basicFieldsData,
        'construction_division_id'
      );
      if (deepIndex) {
        const props= this.basicFieldsData[deepIndex]['props']!;
        props.value = setItem?.id;
        props.outPutData[0]!.value = setItem?.id;
        props.outPutData[1]!.value = setItem?.name;
        this.registData.item['construction_division_id'] = Number(setItem?.id);
      }
    } else if (inputName === 'customer_id') {
      // 取引先マスタ情報から選択されたconstruction_staff_idに関する情報を引き出す
      const checkItem = this.masterData['m_customer'].body.find(v => {
        if (v.id) {
          return v.id === inputValue;
        }
        return false;
      });
      // 工事基本情報からbilling_destination_nameに該当するインデックスを検索する
      let deepIndex = this.constructionModel.getDetailFieldsDataDeepIndex(
        this.basicFieldsData,
        'billing_destination_name'
      );
      if (deepIndex) {
        this.basicFieldsData[deepIndex]['props']!.value = checkItem?.name;
        this.registData.item['billing_destination_name'] = checkItem?.name;
      }

      // 工事基本情報からbilling_person_telに該当するインデックスを検索する
      deepIndex = this.constructionModel.getDetailFieldsDataDeepIndex(
        this.basicFieldsData,
        'billing_person_tel'
      );
      if (deepIndex) {
        this.basicFieldsData[deepIndex]['props']!.value = checkItem?.tel_number;
        this.registData.item['billing_person_tel'] = checkItem?.tel_number;
      }
    }

    const dataType = this.registFieldType[response.name];
    switch (dataType) {
      case 'number':
        response.value = Number(response.value);
        break;
    }
    this.registData.item[response.name] = response.value;
  }

  private createBasicData(response: any) {
    // do nothing.
  }

  private async buttonAction(type: any) {
    switch (type) {
      case 'register': {
        // 自動採番APIから発注申請Noを取得
        const autoNumber = await this.constructionModel.getAutoNumber(hexabaseState.applicationId, hexabaseState.datastoreIds['採番管理'], 'id', {});
        this.registData.item.construction_no = Number(autoNumber.result.value);
        this.constructionModel.registerLinkedItems(hexabaseState.applicationId, this.mainDsId, this.registData);
        break;
      }
    }
  }

  modifyDetailItems(linkedData: { [k: string]: any }){
    const result: { [k: string]: Array<{ [k: string]: any }> } = {};
    if (linkedData['d_id'] === undefined) return {};
    result[linkedData['d_id']] = [];
    const items: Array<{ [k: string]: string }> = linkedData.items;
    items.forEach((element, index) => {
      const itemId = element.i_id;
      const revNo = Number(element.rev_no);
      Object.entries(element).forEach(([key, value]) => {
        const fieldInfo: { [k: string]: string } = linkedData.fields[key];
        if (fieldInfo !== undefined && linkedData.fields[key].dataType !== 'autonum') {
          if (result[linkedData['d_id']][index] === undefined) {
            const initial: { [k: string]: any } = {
              operation: 2,
              i_id: itemId,
              rev_no: revNo,
              item: {}
            };
            initial.item[fieldInfo['display_id']] =
              linkedData.fields[key].dataType === 'number' ? Number(value) : value;
            result[linkedData['d_id']].push(initial);
          } else {
            result[linkedData['d_id']][index]['item'][fieldInfo['display_id']] =
              linkedData.fields[key].dataType === 'number' ? Number(value) : value;
          }
        }
      });
    });
    return result;
  }

  async onSubmit() {
    // 明細に入力されてるデータのみ登録対象とする
    const isItemCheck = (value:any) => value.length !== 0;
    const sendRegistData = JSON.parse(JSON.stringify(this.registData));

    Object.keys(this.registData.related_ds_items).forEach(key => {
      sendRegistData.related_ds_items[key] = [];
      for (const arrayKey in Object.entries(this.registData.related_ds_items[key])){
        const items = Object.values(this.registData.related_ds_items[key][arrayKey].item)
        if (this.registData.related_ds_items[key][arrayKey] === 3 ||
          (
            Object.keys(this.registData.related_ds_items[key][arrayKey].item).length !== 0
            //&& items.every(isItemCheck)
          )
        ) {
          sendRegistData.related_ds_items[key].push(this.registData.related_ds_items[key][arrayKey]);
        }
      }
    });
    try {
      this.apiResponse = await this.constructionModel.updateItems(hexabaseState.applicationId, this.mainDsId, this.itemId, sendRegistData);
      this.syncCurrentDataAndRegistData();
    } catch (e) {
      this.apiResponse = { error: true, errorStatus: e.response.status };
    }
  }

  /**
   * 保持しているDB登録用データをbackendから再取得して更新する
   */
  private async syncCurrentDataAndRegistData() {
    const constructionBasicResult = await this.constructionModel.getLinkedItems(
      hexabaseState.applicationId,
      this.mainDsId,
      this.itemId
    );
    // DB登録用データを更新
    this.currentData = constructionBasicResult.field_values;

    // linked_items内マスタ情報の洗い出し
    this.deleteMasterIds = [];
    for (const key in constructionBasicResult.linked_items) {
      if(constructionBasicResult.linked_items[key].display_id.indexOf(this.searchPattern) === 0) {
        this.deleteMasterIds.push(key);
      }
    }
    // linked_items内マスタ情報の削除
    for (const key in this.deleteMasterIds) {
      delete constructionBasicResult.linked_items[this.deleteMasterIds[key]];
    }

    for (const key in this.currentData) {
      if (this.currentData[key].value) {
        this.registData.item[this.currentData[key].field_id] = this.currentData[key].value;
      }
    }
    this.registData['rev_no'] = constructionBasicResult.rev_no;
    for (const key in constructionBasicResult.linked_items) {
      this.registData.related_ds_items = {
        ...this.registData.related_ds_items,
        ...this.modifyDetailItems(constructionBasicResult.linked_items[key])
      };
    }

    // 明細登録用データがない場合は明細追加時と同様に空の登録用データを用意
    for (const key in this.registData.related_ds_items) {
      if (this.registData.related_ds_items[key].length === 0) {
        this.registData.related_ds_items[key].push(
          {
            operation: 1,
            item: {}
          }
        );
      }
    }

    // 予定原価入力タブにある受注予定額を更新
    const estimateOrderPriceFields = this.currentData.find((v) => {
      if (v.field_id === 'estimate_order_price') {
        return v.value;
      }
    });
    this.estimateOrderPrice = String(estimateOrderPriceFields?.value);
    // 確定原価入力タブにある受注確定額を更新
    const fixedOrderPriceFields = this.currentData.find((v) => {
      if (v.field_id === 'fixed_order_price') {
        return v.value;
      }
    });
    this.fixedOrderPrice = String(fixedOrderPriceFields?.value);
  }

  /**
   * 基本情報パネルで入力された値を受け取り登録データに渡す
   * @public response - インサート用に整形されたデータ
   * @returns void
   */
  private catchFileForm(response: FileFormResponse): void {
    this.registData.rev_no = response.revNumber;
    this.registData.item = {
      ...this.registData.item,
      ...response.item
    }
  }

  /**
   * 編集モードに切り替える
   */
  private async toEdit() {
    // try {
    //   // ローディングをセット
    //   this.$store.commit("hexabase/setIsLoading", true);

      this.isEditMode = true;

    // } catch (error) {
    //   console.error(error);
    // } finally {
    //   this.$store.commit("hexabase/setIsLoading", false);
    // }
  }

  private async onCancel() {
    // 一度でも編集されているかを判定
    if(this.isOnceEdit) {
      // 変更内容破棄確認ダイアログを表示
      this.changeDestructionAlertDialogStatus = true;
    } else {
      // 工事管理個別画面を開きなおす
      window.scrollTo({ top: 0 });
      this.$router.go(0);
    }
  }

  private onCancelToTop(): void {
    window.scrollTo({ top: 0 });
    this.$router.push({ name: 'ConstructionList'});
  }

  /**
   * ポップアップの処理完了時確認ボタン押下時処理
   * @returns {void} - 内部プロパティ変更
   */
  private successOpratipon(): void {
    this.dialogStatus = false;
    // 工事管理個別画面を開きなおす
    window.scrollTo({ top: 0 });
    this.$router.go(0);
  }

  /**
   * ポップアップのキャンセルボタン押下時処理
   * @returns {void} - ポップアップ状態変更（閉じる）
   */
  private catchPopup(): void {
    this.dialogStatus = false;
  }

  /**
   * 帳票ダウンロードダイアログ表示
   * @return {void}
   */
  private openFormDownloadDialog(): void {
    // 帳票ダウンロードダイアログを表示
    this.formDownloadDialogStatus = true;
  }

  /**
   * ダイアログを使用する場合のイベント取得処理
   * 子コンポーネントからEmitされる値をコンソールに出力
   * （値が渡されるか確認用）
   * @module closeFormDownloadDialog
   * @param {Object} e - 子コンポーネントより渡される値
   * @return {void} - コンソールに出力
   */
  private closeFormDownloadDialog(e: DialogStatusResponse): void {
    this.formDownloadDialogStatus = false;
  }

  /**
   * 添付ファイルダイアログ表示
   * @return {void}
   */
  private openFileManagerDialog(isOpen: boolean): void {
    // 添付ファイルダイアログを表示
    this.basicFieldsData.map(fieldData => {
      if(fieldData.display_id === this.fileFieldDisplayId) {
        // Vueにデータ変更を検出させるために$setを利用する
        this.$set(fieldData.props!, 'isOpenFileManagerDialog', isOpen);
      }
    });
  }

  /**
   * 子コンポーネントから受け取る、変更内容破棄確認ダイアログで押下したボタンを受け取る
   * @module changeDestructionAlertDialogConfirmOpratipon
   * @param {Object} value - 子コンポーネントより渡される値([value.isAgree] true：破棄、false：キャンセル)
   */
  private changeDestructionAlertDialogConfirmOpratipon(value: { [k:string]: boolean}): void {
    if(value.isAgree) {
      // 工事管理個別画面を開きなおす
      window.scrollTo({ top: 0 });
      this.$router.go(0);
    } else {
      // ダイアログを閉じる
      this.changeDestructionAlertDialogStatus = false;
    }
  }

  /**
   * 請求累計の計算
   * @param {string}
   */
  private calcBillingAmount(data: Array<Array<FieldChildrenProp>>): string {
    let sum = 0;
    if (data.length > 0) {
      for (const i in data) {
        const billingAmount = data[i].find(function(v) {
          if (v.display_id === 'billing_amount' && v['props']?.value !== undefined) {
            sum += Number(v['props']?.value);
          }
        });     
      }
    }
    return String(sum);
  }
  
  /**
   * 帳票ダウンロードダイアログ表示
   * @return {void}
   */
  private openRegisterCopyDataDialog(): void {
    // 帳票ダウンロードダイアログを表示
    this.registerCopyDataStatus = true;
  }

  /**
   * ダイアログを使用する場合のイベント取得処理
   * 子コンポーネントからEmitされる値をコンソールに出力
   * （値が渡されるか確認用）
   * @module closeRegisterCopyDataDialog
   * @param {Object} e - 子コンポーネントより渡される値
   * @return {void} - コンソールに出力
   */
  private closeRegisterCopyDataDialog(e: DialogStatusResponse): void {
    this.registerCopyDataStatus = false;
  }

}
